import React from 'react';
import { ArrowForwardLong } from '@yme/assets/icons';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { IconWrapperStyled, SVGIconStyled } from './styled';
export function ForwardBtnWithAnimation({ isRightToLeft, color = colorCoreBlack900Base, }) {
    return (React.createElement(IconWrapperStyled, { isRightToLeft: isRightToLeft },
        React.createElement(SVGIconStyled, { isRightToLeft: isRightToLeft, type: ArrowForwardLong, iconRotate: isRightToLeft ? 180 : 0, stroke: color })));
}
